<template>
    <div class="container mar-bt2">
        <div class="row mar-tp1 mar-bt2 align-items-center">
            <i class="fa fa-bandcamp fa-lg mar-r1 text-info"></i>
            <h6>当前位置&nbsp;>&nbsp;<router-link to="/home">首页</router-link>&nbsp;>&nbsp;联系我们</h6>
        </div>
        <div class="row">
            <div class="col-5"><img class="img-suit img-thumbnail" src="../assets/images/contactus.jpg" /></div>
            <div class="col-7 text-left">
                <h4>杭州易梵科技有限公司</h4><p></p>
                <p>公司地址：浙江省杭州市下城区东新路533号蔚蓝国际大厦1号楼404室</p>
                <p>电子邮箱：zjqm@163.com</p>
                <p>公司网址：http://www.evangen.com</p>
                <p><img src="@/assets/images/qcode.png">&nbsp;&nbsp;扫一扫，咨询我们</p>
            </div>   
                     
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>

</style>